"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DropDown = function DropDown(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 20 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 20 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'drop down' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'drop down' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-1390.000000, -24.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "drop-down",
    transform: "translate(1390.000000, 24.000000)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-5-Copy-22",
    stroke: "#31A3F9",
    x: "0.5",
    y: "0.5",
    width: "19",
    height: "19",
    rx: "4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.29747731,13.0114934 L5.50178567,9.26475239 C5.10873514,8.87677078 5.10462596,8.24361914 5.49260757,7.85056861 C5.88058917,7.45751808 6.51374081,7.4534089 6.90679134,7.8413905 L9.99542555,10.8901925 L13.0641294,7.8214887 C13.4546537,7.43096441 14.0878187,7.43096441 14.4783429,7.8214887 C14.8688672,8.21201299 14.8688672,8.84517797 14.4783429,9.23570226 L10.7071068,13.0069384 C10.3181009,13.3959443 9.68833739,13.3974568 9.29745932,13.0114758 Z",
    id: "Drop-Down",
    fill: color,
    fillRule: "nonzero"
  })))));
};
DropDown.propTypes = _index.iconProps;
var _default = DropDown;
exports["default"] = _default;